import { appSettings } from './appSettings';


export const googleMapKey = {
    Map_API_Key: 'AIzaSyAPsFxsOv5qL8zElH-BFVIuwz1G-Ijf7sE'
};


